import React from "react";
import LayoutHeader from "../common/LayoutHeader";
import Footer from "../common/LayoutFooter";

const TermsSection = ({ title, children }) => (
  <section className="mb-5">
    {title && <h2 className="mb-4 fw-bold fs-3">{title}</h2>}
    <div className="text-secondary" style={{ lineHeight: "1.8", fontSize: "1.05rem" }}>
      {children}
    </div>
  </section>
);

const TermsAndConditions = () => {
  return (
    <>
      <LayoutHeader />
      <div className="hn-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="mb-5 pb-3">
                <span className="hn-card-badge mb-2">Legal</span>
                <h1 className="hn-section-title">Terms and Conditions</h1>
              </div>

              <TermsSection>
                <p>
                  HypeNa primarily focuses on listing businesses, events and competitions that cater for the Namibian people. HypeNa also prioritises events that focus on entertainment, culture and community building as opposed to political agendas and protests. HypeNa is an independent company and does not condone inappropriate content and/or hate speech.
                </p>
                <p>
                  HypeNa is a platform for connecting users with businesses, but is not involved in or responsible for any transaction between users and listed businesses. The user acknowledges that any interactions with listed businesses are at their own risk and HypeNa is not liable for any losses or damages incurred.
                </p>
              </TermsSection>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;